import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnDestroy, SimpleChanges, ViewChild } from '@angular/core';
import { Chart, DoughnutController, ArcElement, Tooltip } from 'chart.js';

Chart.register(DoughnutController, ArcElement, Tooltip);

export interface DonutSlice {
    name: string;
    amount: number;
    percentage: number;
    color?: string;
}

const PALETTE = ['#e11d48', '#f97316', '#2563eb', '#eab308', '#94a3b8'];

/** Dona de "Distribución del gasto operativo" + su leyenda lateral. */
@Component({
    selector: 'app-donut-chart',
    templateUrl: './donut-chart.component.html',
    styleUrls: ['./donut-chart.component.css']
})
export class DonutChartComponent implements AfterViewInit, OnChanges, OnDestroy {
    @Input() slices: DonutSlice[] = [];
    @Input() total = 0;

    @ViewChild('canvas') canvasRef?: ElementRef<HTMLCanvasElement>;

    private chart: Chart<'doughnut'> | null = null;

    ngAfterViewInit(): void {
        this.render();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!changes['slices']) return;
        this.render();
    }

    ngOnDestroy(): void {
        this.chart?.destroy();
    }

    color(index: number): string {
        return this.slices[index]?.color || PALETTE[index % PALETTE.length];
    }

    formatCurrency(value: number): string {
        return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value || 0);
    }

    private render(): void {
        const canvas = this.canvasRef?.nativeElement;
        if (!canvas) return;

        const labels = this.slices.map(s => s.name);
        const data = this.slices.map(s => s.amount);
        const colors = this.slices.map((_, i) => this.color(i));

        if (this.chart) {
            this.chart.data.labels = labels;
            this.chart.data.datasets[0].data = data;
            (this.chart.data.datasets[0] as any).backgroundColor = colors;
            this.chart.update();
            return;
        }

        const ctx = canvas.getContext('2d');
        if (!ctx) return;

        this.chart = new Chart(ctx, {
            type: 'doughnut',
            data: {
                labels,
                datasets: [{
                    data,
                    backgroundColor: colors,
                    borderWidth: 0,
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                cutout: '72%',
                plugins: {
                    legend: { display: false },
                    tooltip: {
                        callbacks: {
                            label: (item) => `${item.label}: ${this.formatCurrency(Number(item.parsed))}`
                        }
                    }
                }
            }
        });
    }
}
